const region = {
  getCurrentRegion: function () {
    if (window.localStorage.getItem('CURRENT_REGION')) {
      return JSON.parse(window.localStorage.getItem('CURRENT_REGION'))
    }
    return process.env.REGION || null
  },
  getRegionConfig: function (configObject = {}, currentRegion = null) {
    if (!currentRegion) {
      currentRegion = this.getCurrentRegion()
    }
    if (configObject.hasOwnProperty(currentRegion)) {
      return configObject[currentRegion]
    }
    return configObject.default
  }
}

export default region
